import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
    root: {
        marginBottom: '2rem',
        overflow: 'hidden'
    }
}));
